/**
 * The pencil at the end of a clickable table row: straight to the edit modal,
 * skipping the read-only view the row itself opens. The click and the
 * Enter/Space that would also activate the row stop here.
 */
export function RowEditButton({
  label,
  onEdit,
}: {
  /** What is edited, for the accessible name — "Edit {label}". */
  readonly label: string;
  readonly onEdit: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={`Edit ${label}`}
      title="Edit"
      onClick={(event) => {
        event.stopPropagation();
        onEdit();
      }}
      onKeyDown={(event) => event.stopPropagation()}
      className={[
        "inline-flex size-7 items-center justify-center rounded-hairline border border-transparent",
        "text-ink-faint transition-colors duration-fast ease-swiss",
        "hover:border-rule hover:bg-paper-raised hover:text-ink active:translate-y-px",
      ].join(" ")}
    >
      <svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true">
        <path
          d="M10.75 2.75l2.5 2.5-7.5 7.5H3.25v-2.5l7.5-7.5zM9.25 4.25l2.5 2.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
